// extracted by mini-css-extract-plugin
export var banner = "_8-0";